import { render, staticRenderFns } from "./apparatusFilterData.vue?vue&type=template&id=08de6550&scoped=true"
import script from "./apparatusFilterData.vue?vue&type=script&lang=js"
export * from "./apparatusFilterData.vue?vue&type=script&lang=js"
import style0 from "./apparatusFilterData.vue?vue&type=style&index=0&id=08de6550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08de6550",
  null
  
)

export default component.exports